/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { LeftSide } from './LeftSide'
import { RightSidebar } from './RightSidebar'
import TopBar from '../../components/TopBar'
import { getPage, createPage, updatePage, deletePages } from '../../api/pagesApi'
import { getAllBanners } from '../../api/bannerApi'
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup'

import styles from './page.module.css'
import UploadMediaPopup from '../../components/UploadMediaPopup'
import useMediaUpload from '../../hooks/useMediaUpload'

const NewPage = () => {
    const { pageId } = useParams();
    const deletePopupRef = useRef()
    const navigate = useNavigate();


    /* --- Editor state --- */
    const [updatedContent, setUpdatedContent] = useState("")
    const [editorContent, setEditorContent] = useState("")

    /* --- Page data state --- */
    const [pageData, setPageData] = useState({
        title: '',
        description: '',
        slug: '',
        featureImage: '',
        seoContent: '',
        seoTitle: '',
        keyword: '',
        status: '',
        bannerId: null,
        titleShowed: true,
        showHighlight: false
    })
    const [isSlugChanged, setIslugChanged] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});

    /* --- Button state --- */
    const [published, setPublished] = useState(false);
    const [draft, setDraft] = useState(false);
    const [isPublishedOpen, setIsPublishedOpen] = useState(false);
    const [isDraftOpen, setIsDraftOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDraftLoading, setIsDraftLoading] = useState(false);

    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState('');
    const [selectMediaLoading, setSelectMediaLoading] = useState(false);
    const [isImageDragging, setIsImageDragging] = useState(false);

    const fileList = {
            'image/jpeg': true,
            'image/png': true,
            'image/jpg': true
        };
        const { handleMeidaUpload } = useMediaUpload(setSelectedFeatureImage, null, fileList);

    const bannerDropdownRef = useRef();
    const [bannerList, setBannerList] = useState([]);
    const [openBanner, setOpenBanner] = useState(false);

    useEffect(() => {
        const checkIfClickedOutside = (event) => {
            if (bannerDropdownRef.current && !bannerDropdownRef.current.contains(event.target)) {
                setOpenBanner(false);
            }
            if (deletePopupRef.current && !deletePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
        };

        document.addEventListener("mousedown", checkIfClickedOutside);

        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, []);

    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const response = await getAllBanners();
                setBannerList(response?.data || []);
            } catch (error) {
                setBannerList([]);
            }
        };

        fetchBannerData();
    }, []);

    useEffect(() => {
        if (selectedFeatureImage) {
            setPageData(prev => ({ ...prev, featureImage: selectedFeatureImage }));
        }
    }, [selectedFeatureImage]);

    const getSinglePage = async () => {
        try {
            const response = await getPage(pageId);

            if (response?.success) {
                const pageItem = response?.data || {};

                const responseBanner = await getAllBanners();
                const selectedBanner = responseBanner?.data?.filter((item) =>
                    pageItem?.bannerId?.some((banner) => item.bannerId === banner)
                );

                setPageData({
                    title: pageItem?.title || '',
                    description: pageItem?.description || '',
                    slug: pageItem?.slug || '',
                    featureImage: selectedFeatureImage?.[0]?.id || "",
                    seoContent: pageItem?.seoContent || '',
                    seoTitle: pageItem?.seoTitle || '',
                    keyword: pageItem?.keyword || '',
                    status: pageItem?.status || 'published',
                    bannerId: selectedBanner || [],
                    titleShowed: pageItem?.titleShowed !== undefined ? pageItem?.titleShowed : true,
                    showHighlight: pageItem?.showHighlight !== undefined ? pageItem?.showHighlight : false
                });
                setSelectedFeatureImage((pageItem?.featureImage !== '' && pageItem?.featureImage) ? [pageItem?.featureImage] : null)

                setEditorContent(
                    pageItem?.description === "<p></p>" ? "" : pageItem?.description
                );
                setUpdatedContent(
                    pageItem?.description === "<p></p>" ? "" : pageItem?.description
                );

                if (pageItem?.status === "published") {
                    setPublished(true);
                    setDraft(false);
                } else if (pageItem?.status === "draft") {
                    setDraft(true);
                    setPublished(false);
                }
            }
        } catch (error) {
            console.log({ error });
        }
    };

    useEffect(() => {
        if (pageId && pageId !== undefined && pageId !== '') {
            getSinglePage()
        }
    }, [pageId])

    const handleBannerSelect = (banner) => {
        setPageData(prev => {
            const currentBanners = Array.isArray(prev?.bannerId) ? prev.bannerId : (prev?.bannerId ? [prev.bannerId] : []);
            const exists = currentBanners.some(b => b?.bannerId === banner?.bannerId);
            let newBanners;
            if (exists) {
                newBanners = currentBanners.filter(b => b?.bannerId !== banner?.bannerId);
            } else {
                newBanners = [...currentBanners, banner];
            }
            return { ...prev, bannerId: newBanners };
        });
    };

    const handleContentChange = (newContent) => {
        setUpdatedContent(newContent);
        setErrorMessage((prev) => ({
            ...prev,
            description: ''
        }));
    };

    function convertToSlug(str) {
        let slug = str.toLowerCase();

        slug = slug.trim();

        slug = slug.replace(/[^a-z0-9\s-]/g, '');

        slug = slug.replace(/\s+/g, '-');

        return slug;
    }

    const changeSlug = (value) => {
        if (!isSlugChanged) {
            let urlValue = convertToSlug(value);
            setPageData({ ...pageData, slug: urlValue });
        }
    }

    const changeTitle = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            return true;
        }
    }

    const changesTitles = (e) => {
        const text = e.target.innerText.replace(/<[^>]+>/g, '');

        if (text.length <= 120 || e.key === 'Backspace') {
            // setPageTitle(text)
            changeSlug(text);
        } else {
            e.preventDefault();
            return true;
        }
    }

    const handleBlur = (e) => {
        const text = e.target.innerText.replace(/<[^>]+>/g, '').trim();
        setPageData({ ...pageData, title: text })
    }

    const handlePaste = (e) => {
        e.preventDefault();

        // Get the plain text content from clipboard
        const clipboardData = e.clipboardData.getData('text/plain');

        // Paste the plain text into the contenteditable div
        document.execCommand('insertText', false, clipboardData);
    }

    const validatePublishPage = () => {
        const errors = {};

        if (!pageData?.title?.trim()) {
            errors.title = "Title is required";
        }

        const content = updatedContent || editorContent;
        if (!content || !content.trim() || content === "<p></p>") {
            errors.description = "Description is required";
        }

        if (!pageData?.slug?.trim()) {
            errors.slug = "URL is required";
        }

        setErrorMessage(errors);

        return Object.keys(errors).length === 0;
    };

    const validateDraftPage = () => {
        setIsDraftLoading(false);
        const errors = {};

        if (!pageData?.title?.trim()) {
            errors.title = "Title is required";
        }

        setErrorMessage(errors);

        return Object.keys(errors).length === 0;
    };


    const handlePublish = async () => {
        if (!validatePublishPage()) return;
        setIsLoading(true);
        try {
            const data = {
                title: pageData.title,
                description: updatedContent || editorContent,
                slug: pageData.slug,
                featureImage: selectedFeatureImage?.[0]?.id || "",
                seoContent: pageData.seoContent,
                seoTitle: pageData.seoTitle,
                keyword: pageData.keyword,
                status: 'published',
                bannerId: pageData?.bannerId && Array.isArray(pageData?.bannerId) ? pageData?.bannerId?.map(banner => banner?.bannerId) : null,
                titleShowed: pageData?.titleShowed !== undefined ? pageData?.titleShowed : true,
                showHighlight: pageData?.showHighlight !== undefined ? pageData?.showHighlight : true
            };
            if (pageId) {
                await updatePage(pageId, data);
            } else {
                const response = await createPage(data);
                if (response?.success) {
                    const updateResponse = await updatePage(response?.data?.pageId, response?.data);
                    if (updateResponse?.success) {
                        navigate(`/page/${response?.data?.pageId}`)
                    }
                }
            }
            setPublished(true);
            setDraft(false);
            setPageData({ ...pageData, status: 'published' });
        } catch (error) {
            console.log(error);
            const errors = {};

            if (error?.response?.data?.error?.message === "Page slug already exists") {
                errors.slug = "Title is required";
            }

            setErrorMessage({ ...errorMessage, slug: error?.response?.data?.error?.message });
        }
        setIsLoading(false);
    };

    const handleDraft = async () => {
        if (!validateDraftPage()) return;
        try {
            setIsDraftLoading(true);
            const data = {
                title: pageData.title,
                description: updatedContent || editorContent,
                slug: pageData.slug,
                featureImage: selectedFeatureImage?.[0]?.id || "",
                seoContent: pageData.seoContent,
                seoTitle: pageData.seoTitle,
                keyword: pageData.keyword,
                status: 'draft',
                bannerId: pageData?.bannerId && Array.isArray(pageData?.bannerId) ? pageData?.bannerId?.map(banner => banner?.bannerId) : null,
                titleShowed: pageData?.titleShowed !== undefined ? pageData?.titleShowed : true,
                showHighlight: pageData?.showHighlight !== undefined ? pageData?.showHighlight : true
            };
            if (pageId) {
                await updatePage(pageId, data);
            } else {
                const response = await createPage(data);
                if (response?.success) {
                    const updateResponse = await updatePage(response?.data?.pageId, response?.data);
                    if (updateResponse?.success) {
                        navigate(`/page/${response?.data?.pageId}`)
                    }
                }
            }
            setDraft(true);
            setPublished(false);
            setPageData({ ...pageData, status: 'draft' });
            setIsDraftLoading(false);
            setIsLoading(false)
        } catch (error) {
            console.log(error);
            const errors = {};

            if (error?.response?.data?.error?.message === "Page slug already exists") {
                errors.slug = "Title is required";
            }

            setErrorMessage({ ...errorMessage, slug: error?.response?.data?.error?.message });
            setIsDraftLoading(false);
            setIsLoading(false)
        }
    };

    const handleChangeToDraft = async () => {
        if (!validateDraftPage()) return;
        if (published) {
            setIsLoading(true);
            try {
                const data = { ...pageData, status: 'draft', bannerId: pageData?.bannerId && Array.isArray(pageData?.bannerId) ? pageData?.bannerId?.map(banner => banner?.bannerId) : null };
                await updatePage(pageId, data);
                setPublished(false);
                setDraft(true);
                setPageData({ ...pageData, status: 'draft' });
                setIsPublishedOpen(false);
            } catch (error) {
                console.log(error);
            }
            setIsLoading(false);
        }
    };

    const handleChangeToPublish = async () => {
        if (!validatePublishPage()) return;
        if (draft) {
            setIsLoading(true);
            try {
                const data = { ...pageData, status: 'published', bannerId: pageData?.bannerId && Array.isArray(pageData?.bannerId) ? pageData?.bannerId?.map(banner => banner?.bannerId) : null };
                await updatePage(pageId, data);
                setDraft(false);
                setPublished(true);
                setPageData({ ...pageData, status: 'published' });
                setIsDraftOpen(false);
            } catch (error) {
                console.log(error);
            }
            setIsLoading(false);
        }
    };

    const handelSingleDelete = async () => {
        setShowDeletePopup(true)
    };

    const confirmDelete = async () => {
        try {
            const response = await deletePages([pageId]);
            if (response?.success) {
                navigate('/all-pages');
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleFileDragOver = (e) => {
        e.preventDefault();
        setIsImageDragging(true);
    };

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const handleFeatureImageDrop = async (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        const maxSizeInBytes = 128 * 1024 * 1024;
        const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const validFiles = Array.from(files).filter(file => {
            if (!allowedFileTypes.includes(file.type)) return false;
            if (file.size > maxSizeInBytes) return false;
            return true;
        }).slice(0, 1);
        handleMeidaUpload(validFiles);
        setIsImageDragging(false);
    };

    return (
        <>
            <TopBar />
            <div className={styles.contentWrapper}>
                <div className={styles.newpageContent} >
                    <LeftSide styles={styles} pageData={pageData} setPageData={setPageData} isSlugChanged={isSlugChanged} changeSlug={changeSlug} changeTitle={changeTitle} changesTitles={changesTitles} handleBlur={handleBlur} handlePaste={handlePaste} errorMessage={errorMessage} setErrorMessage={setErrorMessage} editorContent={editorContent} setEditorContent={setEditorContent} handleContentChange={handleContentChange} pageId={pageId} />
                    <RightSidebar
                        styles={styles}
                        pageData={pageData}
                        setPageData={setPageData}
                        setIslugChanged={setIslugChanged}
                        changeSlug={changeSlug}
                        convertToSlug={convertToSlug}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        published={published}
                        draft={draft}
                        isPublishedOpen={isPublishedOpen}
                        setIsPublishedOpen={setIsPublishedOpen}
                        isDraftOpen={isDraftOpen}
                        setIsDraftOpen={setIsDraftOpen}
                        isLoading={isLoading}
                        isDraftLoading={isDraftLoading}
                        handlePublish={handlePublish}
                        handleDraft={handleDraft}
                        handleChangeToDraft={handleChangeToDraft}
                        handleChangeToPublish={handleChangeToPublish}
                        handelSingleDelete={handelSingleDelete}
                        pageId={pageId}
                        setIsDraftLoading={setIsDraftLoading}
                        setIsLoading={setIsLoading}
                        validateDraftPage={validateDraftPage}
                        bannerList={bannerList}
                        handleBannerSelect={handleBannerSelect}
                        bannerDropdownRef={bannerDropdownRef}
                        openBanner={openBanner}
                        setOpenBanner={setOpenBanner}
                        setShowUploadMediaPopup={setShowUploadMediaPopup}
                        uploadMediaPopupFor={uploadMediaPopupFor}
                        setUploadMediaPopupFor={setUploadMediaPopupFor}
                        uploadMediaPopupTab={uploadMediaPopupTab}
                        isImageDragging={isImageDragging}
                        setImageDragging={setIsImageDragging}
                        handleFeatureImageDrop={handleFeatureImageDrop}
                        handleFileDragOver={handleFileDragOver}
                        handleFileDragLeave={handleFileDragLeave}
                        handleMeidaUpload={handleMeidaUpload}
                        selectedFeatureImage={selectedFeatureImage}
                        setSelectedFeatureImage={setSelectedFeatureImage}
                        setUploadMediaPopupTab={setUploadMediaPopupTab}
                    />
                </div>
            </div>
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={deletePopupRef}
                title={'page'}
                description={'Are you sure you want to delete this page? This action cannot be undone.'}
                confirmDelete={confirmDelete}
            />
            {showUploadMediaPopup &&
                <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} selectMediaLoading={selectMediaLoading} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
            }
        </>
    )
}

export default NewPage